import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons/faAngleDown';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons/faMagnifyingGlass';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faXmark } from '@fortawesome/free-solid-svg-icons/faXmark';
import domLoaded from 'dom-loaded';

library.add(
  faAngleDown,
  faBars,
  faMagnifyingGlass,
  faPlus,
  faXmark,
);

domLoaded.then(function() {
  // Use FontAwesome to setup static SVG icons within the header/footer.
  //
  // Only replace icons in the header/footer portions that are explicitly
  // wrapped in an `eere-enable-template-icons` class, so that our template
  // icons don't interfere with any FontAwesome usage (of different versions)
  // in the content/body portion of the app.
  //
  // 2025 Note: This may not be quite as isolated and scoped as originally
  // intended. It seems like if the client app also uses font awesome and calls
  // `dom.watch()` that ends up adding any icons defined in `library.add()`
  // above globally, regardless of this scoping here. This seems to be because
  // FontAwesome really has just 1 library and operates on a global
  // `window.___FONT_AWESOME___`, so despite any scoping we do here, it really
  // affects page-wide FontAwesome usage. So while this loop is potentially
  // unncessary or duplicative if the client app calls `dom.watch()`, still
  // leaving it here in case the client app doesn't directly use FontAwesome or
  // if FontAwesome provides more isolated APIs in the future.
  const nodes = document.querySelectorAll('.eere-enable-template-icons');
  for (let i = 0, len = nodes.length; i < len; i++) {
    dom.i2svg({ node: nodes[i] });
  }
});
